export default class ThemecustomCrudService {
  getAll() {
    return fetch("https://api.tradersr.com/api/themecustomcrud")
      .then(res => res.json());
  }
}